import { API } from "./api";

export class OAuthAPI extends API {}

export default OAuthAPI;
